/**
 * Debug utilities for authentication and permissions
 * Use in browser console: window.debugAuth()
 */

export function debugAuth() {
  const user = localStorage.getItem('user');
  const accessToken = localStorage.getItem('access_token');
  const refreshToken = localStorage.getItem('refresh_token');

  console.group('🔍 Auth Debug Info');

  console.log('📦 LocalStorage Keys:', Object.keys(localStorage));

  console.log('\n🔑 Tokens:', {
    hasAccessToken: !!accessToken,
    hasRefreshToken: !!refreshToken,
    accessTokenLength: accessToken?.length || 0,
  });

  if (user) {
    try {
      const userData = JSON.parse(user);
      console.log('\n👤 User Data:', userData);
      console.log('\n🎭 Role Info:', {
        'user.role': userData.role,
        'user.primaryRole': userData.primaryRole,
        'user.roles': userData.roles,
      });
      console.log('\n🔒 Permissions:', userData.permissions);
    } catch (e) {
      console.error('❌ Failed to parse user data:', e);
      console.log('Raw user data:', user);
    }
  } else {
    console.warn('⚠️ No user data in localStorage');
  }

  console.groupEnd();
}

export function clearAuthCache() {
  console.log('🧹 Limpando cache de autenticação...');
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('user');
  console.log('✅ Cache limpo! Faça login novamente.');
  window.location.href = '/login';
}

// Expose to window for easy console access
if (typeof window !== 'undefined') {
  (window as any).debugAuth = debugAuth;
  (window as any).clearAuthCache = clearAuthCache;
}

export function logRoleCheck(context: string, user: any, requiredRole?: string) {
  console.group(`🔐 Role Check: ${context}`);
  console.log('User role:', user?.role);
  console.log('User primaryRole:', user?.primaryRole);
  console.log('Required role:', requiredRole);
  console.groupEnd();
}
